'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import notFoundNewConsumerApp from 'commons/notFoundNewConsumerApp';
import ProductListingPage from 'components/consumer/ProductListingPage';
import CategoryStoresContext from 'data-hooks/context/CategoryStoresContext';
import useProductStoresForCategory from 'data-hooks/useProductStoresForCategory';
import useCategoryPageData from './hooks/useCategoryPageData';
import SuspenseWithLoader from '../SuspenseWithLoader';
import ProductListingPagePlaceholder from '../ProductListingPage/ProductListingPagePlaceholder';
const stripLeadingAndTrailingSlash = path => {
  const pathWithoutLeadingSlash = path.startsWith('/') ? path.slice(1) : path;
  const pathWithoutTrailingSlash = pathWithoutLeadingSlash.endsWith('/') ? pathWithoutLeadingSlash.slice(0, -1) : pathWithoutLeadingSlash;
  return pathWithoutTrailingSlash;
};

// Note: The CategoryPageWithData component is separated from the CategoryPage
// component so it can be keyed by slug to ensure that fresh data is rendered
// for each category page.
const CategoryPageWithData = t0 => {
  const $ = _c(16);
  const {
    sidebarHeader,
    slug
  } = t0;
  const location = useLocation();
  let t1;
  if ($[0] !== slug) {
    t1 = {
      slug
    };
    $[0] = slug;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const pageData = useCategoryPageData(t1);
  let t2;
  if ($[2] !== location.search) {
    const searchParams = new URLSearchParams(location.search);
    t2 = searchParams.get("showMultipleStores");
    $[2] = location.search;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const enableMultipleStores = t2 === "true";
  const t3 = !enableMultipleStores;
  let t4;
  if ($[4] !== slug || $[5] !== t3) {
    t4 = {
      categorySlug: slug,
      skip: t3
    };
    $[4] = slug;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const storesContext = useProductStoresForCategory(t4);
  let t5;
  let t6;
  if ($[7] !== pageData) {
    t5 = () => {
      if (pageData && !pageData?.loading && !pageData?.pageId) {
        notFoundNewConsumerApp();
      }
    };
    t6 = [pageData];
    $[7] = pageData;
    $[8] = t5;
    $[9] = t6;
  } else {
    t5 = $[8];
    t6 = $[9];
  }
  useEffect(t5, t6);
  let t7;
  if ($[10] !== pageData || $[11] !== sidebarHeader) {
    t7 = <ProductListingPage pageData={pageData} sidebarHeader={sidebarHeader} />;
    $[10] = pageData;
    $[11] = sidebarHeader;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== storesContext || $[14] !== t7) {
    t8 = <CategoryStoresContext.Provider value={storesContext}>{t7}</CategoryStoresContext.Provider>;
    $[13] = storesContext;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
CategoryPageWithData.propTypes = {
  sidebarHeader: PropTypes.node,
  slug: PropTypes.string
};
const CategoryPage = t0 => {
  const $ = _c(9);
  const {
    sidebarHeader
  } = t0;
  const location = useLocation();
  const pathname = location?.pathname || "";
  let t1;
  if ($[0] !== pathname) {
    t1 = stripLeadingAndTrailingSlash(pathname);
    $[0] = pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const slug = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ProductListingPagePlaceholder />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== sidebarHeader || $[4] !== slug) {
    t3 = <CategoryPageWithData key={slug} sidebarHeader={sidebarHeader} slug={slug} />;
    $[3] = sidebarHeader;
    $[4] = slug;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== slug || $[7] !== t3) {
    t4 = <SuspenseWithLoader fallback={t2} key={slug}>{t3}</SuspenseWithLoader>;
    $[6] = slug;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
CategoryPage.propTypes = {
  sidebarHeader: PropTypes.node
};
export default CategoryPage;